import i18n from '@/VueI18n'
import { SortOption } from '../../../ui/components/baseTable/dtos/SortOption.dto'
import { TableColumn } from '../../../ui/components/baseTable/dtos/TableColumn.dto'
import FireOutbreakCardReactionMenu from '../components/FireOutbreakCardReactionMenu.vue'
import { SortDirection } from '../../../ui/components/baseTable/enums/SortDirection.enum'

export class FireAlertsTableHeadersFactory {
	// Colunas que o usuário pode ocultar/exibir (também valem para a exportação).
	static readonly OPTIONAL_COLUMNS = [
		{ labelKey: 'fireRiskDashboardId', key: 'codeLabel' },
		{ labelKey: 'fireRiskDashboardCoordX', key: 'longitude' },
		{ labelKey: 'fireRiskDashboardCoordY', key: 'latitude' },
	]

	static make(sortOptions: SortOption[], visibleOptionalColumns: string[]): TableColumn[] {
		const headers = [
			{
				name: i18n.t('fireRiskDashboardId') as string,
				key: 'codeLabel',
				enableSort: true,
				sortActive: sortOptions.find((sort) => sort.key === 'codeLabel')?.direction,
			},
			{
				name: i18n.t('fireRiskDashboardCoordX') as string,
				key: 'longitude',
				enableSort: true,
				sortActive: sortOptions.find((sort) => sort.key === 'longitude')?.direction,
			},
			{
				name: i18n.t('fireRiskDashboardCoordY') as string,
				key: 'latitude',
				enableSort: true,
				sortActive: sortOptions.find((sort) => sort.key === 'latitude')?.direction,
			},
			{
				name: i18n.t('fireRiskDashboardDetection') as string,
				key: 'detectedAtLabel',
				enableSort: true,
				sortKey: 'detectedAt',
				sortActive: sortOptions.find((sort) => sort.key === 'detectedAt')
					?.direction as SortDirection,
			},
			{
				name: i18n.t('fireRiskDashboardCommunication') as string,
				key: 'statedAtLabel',
				enableSort: true,
				sortKey: 'statedAt',
				sortActive: sortOptions.find((sort) => sort.key === 'statedAt')?.direction,
			},
			{
				name: i18n.t('fireRiskDashboardFarm') as string,
				key: 'farm',
				enableSort: true,
				sortActive: sortOptions.find((sort) => sort.key === 'farm')?.direction,
			},
			{
				name: i18n.t('fireRiskDashboardClimaticRisk') as string,
				key: 'riskLabel',
				enableSort: true,
				sortActive: sortOptions.find((sort) => sort.key === 'riskLabel')?.direction,
			},
			{
				name: i18n.t('fireRiskDashboardSatellite') as string,
				key: 'satellite',
				enableSort: true,
				sortActive: sortOptions.find((sort) => sort.key === 'satellite')?.direction,
			},
			{
				name: i18n.t('fireRiskDashboardRadiance') as string,
				key: 'radianceLabel',
				enableSort: true,
				sortKey: 'radiance',
				sortActive: sortOptions.find((sort) => sort.key === 'radiance')?.direction,
			},
			{
				name: i18n.t('fireRiskDashboardConfidence') as string,
				key: 'detectionConfidenceLabel',
				enableSort: true,
				sortKey: 'detectionConfidence',
				sortActive: sortOptions.find((sort) => sort.key === 'detectionConfidence')?.direction,
			},
			{
				name: i18n.t('fireRiskDashboardLocation') as string,
				key: 'occurrenceLabel',
				enableSort: true,
				sortKey: 'occurrence',
				sortActive: sortOptions.find((sort) => sort.key === 'occurrence')?.direction,
			},
			{
				name: i18n.t('fireRiskDashboardEvaluation') as string,
				key: 'reaction',
				component: FireOutbreakCardReactionMenu,
			},
		]

		return headers.filter((header) => this.isVisible(header.key, visibleOptionalColumns))
	}

	static isVisible(key: string, visibleOptionalColumns: string[]): boolean {
		const isOptional = this.OPTIONAL_COLUMNS.some((column) => column.key === key)
		return !isOptional || visibleOptionalColumns.includes(key)
	}
}
